export default __webpack_public_path__ + "static/media/headerSmall.fafdc9ca.svg";